
import { ReservationService } from "./../services/reservation-service/reservation.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { UserServiceService } from "./../services/user-service/user-service.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import swal from "sweetalert2";
import { PaginationComponent } from "../layout/pagination/pagination.component";
import { environment } from "../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { removeNullishFieldsParams } from "../shared/object_helpers";

@Component({
  selector: "app-erp-logs",
  templateUrl: "./erp-logs.component.html",
  styleUrls: ["./erp-logs.component.css"],
})
export class ErpLogsComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  filter_expand = false;
  filterForm: FormGroup;
  logs: any;
  function_types: any;
  json: string = "";
  id_count: number = 1;
  store_banks;
  selectedLogIds: number[] = [];
  isSendingSelected: boolean = false;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserServiceService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService
  ) {
    activatedRoute.queryParams.subscribe((params) => {
      this.intializeFilterForm();
      this.filterForm.patchValue(params);
      params.store_status && this.filterForm.get("store_status").setValue(params.store_status);
    });
  }

  ngOnInit() {
    this.getERPLogs();
    this.getFailedErpFunctionType();
    this.getStoreBanks();
  }

  compareByValueFn(item1: any, item2: any) {
    return item1 && item2 ? item1.value == item2.value : item1 == item2;
  }

  getStoreBanks() {
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
    );
  }

  intializeFilterForm() {
    this.filterForm = this.formBuilder.group({
      reservation_id: [null],
      store_status: [null],
      status: [null],
      function_type: [null],
      date_from: [null],
      date_to: [null],
    });
  }

  getERPLogs() {
    let payload = this.filterForm.value;
    this.paginationRef && (payload =  this.paginationRef.filters)
    this.paginationRef && (payload.page =  this.paginationRef.page)
    this.slimLoadingService.start();
    this.reservationService.getERPLogs(payload).subscribe(
      (res: any) => {
        this.logs = res;
        this.selectedLogIds = [];
        this.id_count = this.logs.from
        this.logs.data.forEach((log) => {
          log.id_count = this.id_count;
          this.id_count++;
        })
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  getFailedErpFunctionType() {
    this.slimLoadingService.start();
    this.reservationService.getFailedErpFunctionType().subscribe(
      (res: any) => {
        this.function_types = res;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  setStatusFilter(status: string) {
    this.filterForm.get("status").setValue(status);
    console.log(this.filterForm.value);
    this.paginationRef.filters.status = status
    this.filter();
  }

  sendAgain(id) {
    this.reservationService.sendFailedERPRequest(id).subscribe(
      (res: any) => {
        swal("Success!", res.message, "success");
        this.paginationRef.infinite();
      },
      (err) => {
        console.error(err);
        swal("Oops...", err.error.message, "error");
      }
    );
  }

  sendSelected() {
    if (!this.selectedLogIds.length || this.isSendingSelected) {
      return;
    }

    this.isSendingSelected = true;
    this.reservationService.sendSelectedFailedERPRequests(this.selectedLogIds).subscribe(
      (res: any) => {
        swal("Success!", res.message, "success");
        this.selectedLogIds = [];
        this.paginationRef.infinite();
        this.isSendingSelected = false;
      },
      (err) => {
        console.error(err);
        swal("Oops...", err.error.message, "error");
        this.isSendingSelected = false;
      }
    );
  }

  toggleLogSelection(id: number, checked: boolean) {
    if (checked) {
      if (this.selectedLogIds.indexOf(id) === -1) {
        this.selectedLogIds.push(id);
      }
      return;
    }

    this.selectedLogIds = this.selectedLogIds.filter((selectedId) => selectedId !== id);
  }

  isLogSelected(id: number): boolean {
    return this.selectedLogIds.indexOf(id) !== -1;
  }

  toggleAllLogsSelection(checked: boolean) {
    if (!this.logs || !this.logs.data) {
      return;
    }

    if (checked) {
      this.selectedLogIds = this.logs.data.map((log) => log.id);
      return;
    }

    this.selectedLogIds = [];
  }

  areAllLogsSelected(): boolean {
    return !!(
      this.logs &&
      this.logs.data &&
      this.logs.data.length &&
      this.selectedLogIds.length === this.logs.data.length
    );
  }

  copyCurl(data: any): void {
    data = JSON.stringify(data);
    if (!data) {
      swal("Oops...", "Data Object is empty or undefined!", "error");
      console.error("Data Object is empty or undefined.");
      return;
    }

    if (navigator && "clipboard" in navigator) {
      (navigator as any).clipboard
        .writeText(data)
        .then(() => {
          swal("Success!", "Data Object copied to clipboard!", "success");
        })
        .catch((err) => {
          console.error("Failed to copy Data Object: ", err);
          swal("Oops...", "Failed to copy Data Object!", "error");
        });
    }
  }

  copyErrorMessage(message) {
    if (navigator && "clipboard" in navigator) {
      (navigator as any).clipboard
        .writeText(message)
        .then(() => {
          swal("Success!", "Error Response copied to clipboard!", "success");
        })
        .catch((err) => {
          console.error("Failed to copy Error Response: ", err);
          swal("Oops...", "Failed to copy Error Response!", "error");
        });
    }
  }

  getNewRecord(event) {
    this.logs = event;
    this.selectedLogIds = [];
    this.id_count = this.logs.from
    this.logs.data.forEach((log) => {
      log.id_count = this.id_count;
      this.id_count++;
    })
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    let qparams = removeNullishFieldsParams(this.filterForm.value);
    if(qparams.store_status) {
      qparams.store_status = Number(qparams.store_status);
    }
    this.router.navigate(
      [], 
      {
        relativeTo: this.activatedRoute,
        queryParams: qparams,
      }
    );
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.intializeFilterForm();
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }

  deleteLog(id) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this log!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.reservationService.deleteLog(id).subscribe(
          (res: any) => {
            this.getERPLogs();
            swal("success", "Deleted log successfully!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "warning");
      }
    })
  }

  parse(obj: any, id: number): void {
    this.json = JSON.stringify(obj, null, 2);
    localStorage.setItem("json", this.json);
    const url = `/pages/edit-erp-log-data/${id}`;
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/erp-logs/erp-logs.component.ts